import React from 'react';
var defaultProps = {
  className: ''
};
export default function Phone(_ref) {
  var phone = _ref.phone,
    className = _ref.className;
  if (!phone) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    className: className,
    href: "tel:".concat(phone)
  }, phone);
}
Phone.defaultProps = defaultProps;